import { useEffect, useState } from "react";
import Header from "./Header";
import Hero from "./Hero";
import Features from "./Feature/Feature";
import Screenshots from "./Screenshots/Screenshots";
import Pricing from "./Pricing/Pricing";
// import Testimonials from "./Testimonial/Testimonials";
import Contact from "./Contact";
import { ContactFormData } from "./contact-form-data.types";
import Footer from "./Footer";
import AdditionalFeatures from "./AdditionalFeatures/AdditionalFeatures";
import { sendContactForm } from "../../services/api.services";
import ToastContainer, { ToastMessage } from "../../components/ToastContainer";

function LandingPage() {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const [formData, setFormData] = useState<ContactFormData>({
    name: '',
    email: '',
    phone: '',
    restaurant: '',
    message: '',
    from: ''
  });
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const showToast = (message: string, type: 'success' | 'error' | 'info' | 'warning' = 'info', duration: number = 5000) => {
    const id = Date.now().toString();
    setToasts((prev) => [...prev, { id, message, type, duration }]);
  };

  const removeToast = (id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };

  useEffect(() => {
    const handleScroll = (): void => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    formData.from = 'landing-page';
    sendContactForm(formData)
      .then((response) => {
        showToast('Obrigado pelo contato! Entraremos em contato em breve.', 'success');
        setFormData({ name: '', email: '', restaurant: '', message: '', phone: '',  from: '' });
        console.log('Resposta da API:', response);
      })
      .catch((error) => {
        console.error('Erro ao enviar formulário:', error);
        showToast(error.message ? error.message : 'Erro ao enviar o formulário. Tente novamente mais tarde.', 'error');
      });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const scrollToSection = (sectionId: string, text?: string): void => {
    console.log('[scrollToSection]')
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      if (text && sectionId === 'contato') {
        setFormData({
          ...formData,
          message: text
        });
      }
    }
  };

  return (
    <div className="font-sans">
      <ToastContainer toasts={toasts} onRemove={removeToast} />
      <Header isScrolled={isScrolled} scrollToSection={scrollToSection} />
      <Hero scrollToSection={scrollToSection} />
      <Features />
      <AdditionalFeatures />
      <Screenshots />
      <Pricing scrollToSection={scrollToSection} />
      {/* <Testimonials /> */}
      <Contact
        formData={formData}
        handleSubmit={handleSubmit}
        handleInputChange={handleInputChange}
      />
      <Footer />
    </div>
  );
};

export default LandingPage;